module.exports = __webpack_public_path__ + "static/media/Comfortaa-Regular.d350ce24.ttf";